import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./EditUser.css";
import openNotification from "components/utils/CustomNotification";

const privilegeOptions = ["orgadmin", "user"];
const userRoles = ["viewer", "creator", "guest", "assigner", "all"];
const deviceControlRoles = ["view only", "submit only", "add and submit"];
const sessionTimeoutOptions = ["00:20:00", "00:40:00", "00:60:00", "00:80:00"];
const refreshTimeOptions = ["00:01:00", "00:02:00", "00:03:00", "00:04:00", "00:05:00"];
const release_group = ["stable","alpha","beta"];
const user_manage_access_options = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

type EditableUserProfile = {
  user_uid: string;
  user_type: string;
  org_uid: string;
  password: string;
  privilege: string;
  user_role: string;
  user_manage_access: boolean;
  device_control: boolean;
  device_control_role: string;
  session_timeout: string;
  refresh_time: string;
  is_log_enabled?: boolean;
is_force_data_push_enabled?: boolean;
is_leader?:boolean;
  log_level?: string;
  release_group:string;
};

const EditUser: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state as EditableUserProfile;

  const sessionUid = localStorage.getItem("session_uid") ?? "";
  const userUid = localStorage.getItem("user_uid") ?? "";
  const API_URL = `${process.env.REACT_APP_API_URL}/api/user-profile`;

  const [editedUser, setEditedUser] = useState<EditableUserProfile>({
    ...user,
    is_log_enabled: user.is_log_enabled ?? false,
    is_force_data_push_enabled: user.is_force_data_push_enabled ?? false,
    is_leader: user.is_leader ?? false,

  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditedUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const payload = { ...editedUser };
  //   try {
  //     await axios.put(API_URL, payload, {
  //       headers: {
  //         "session-uid": sessionUid,
  //         "user-uid": userUid,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     navigate(-1);
  //   } catch (err) {
  //     console.error("Failed to update user profile:", err);
  //   }
  // };

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  // Helper to get changed fields only
  const getUpdatedFields = <T extends object>(
    original: T,
    updated: T
  ): Partial<T> => {
    const updatedFields: Partial<T> = {};

    for (const key in updated) {
      if (Object.prototype.hasOwnProperty.call(updated, key)) {
        const typedKey = key as keyof T;
        if (updated[typedKey] !== original[typedKey]) {
          updatedFields[typedKey] = updated[typedKey];
        }
      }
    }

    return updatedFields;
  };

  // Get only changed fields
  const payload = getUpdatedFields<EditableUserProfile>(user, editedUser);

  //  Always include required fields
  payload.user_uid = user.user_uid;
  payload.user_type = user.user_type;
  payload.org_uid = user.org_uid;
   payload.user_role = editedUser.user_role;


  try {
    const response = await axios.put(API_URL, payload, {
      headers: {
        "user-uid": userUid,
        "Content-Type": "application/json",
      },withCredentials: true,
    });

    if (response.status === 200 && response.data.status === "Success") {
      openNotification({
        type: "success",
        message: response.data.message,
      });
      navigate(-1);
    } else {
      openNotification({
        type: "error",
        message: response.data.data,
      });
    }

  } catch (err) {
    console.error("Failed to update user profile:", err);
    openNotification({
      type: "error",
      message: "An error occurred while updating the user profile.",
    });
  }
};

  return (
    <div className="edit-user-container">
      <h2 className="EditUser-h2" style={{margin:"5px"}}>Edit User</h2>
      <form onSubmit={handleSubmit} className="EditUser-edit-user-form">
        <div className="EditUser-form-grid">
          <div className="EditUser-form-group">
            <label>Privilege</label>
            <select name="privilege" value={editedUser.privilege} onChange={handleChange}>
              {privilegeOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
          <div className="EditUser-form-group">
            <label>User Role</label>
            <select name="user_role" value={editedUser.user_role} onChange={handleChange}>
              {userRoles.map((role) => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>
          {/* <div className="EditUser-form-group">
            <label>Device Control Role</label>
            <select name="device_control_role" value={editedUser.device_control_role} onChange={handleChange}>
              {deviceControlRoles.map((role) => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div> */}
          <div className="EditUser-form-group">
  <label>Session Timeout</label>
  <select
    name="session_timeout"
    value={editedUser.session_timeout}
    onChange={handleChange}
  >
    {sessionTimeoutOptions.map((time) => {
      const parts = time.split(":"); 
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      const totalMinutes = hours * 60 + minutes; // convert HH:MM:SS into minutes
      return (
        <option key={time} value={time}>
          {totalMinutes} minutes
        </option>
      );
    })}
  </select>
</div>

<div className="EditUser-form-group">
  <label>Refresh Time</label>
  <select
    name="refresh_time"
    value={editedUser.refresh_time}
    onChange={handleChange}
  >
    {refreshTimeOptions.map((time) => {
      const parts = time.split(":"); 
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      const totalMinutes = hours * 60 + minutes;
      return (
        <option key={time} value={time}>
          {totalMinutes} minutes
        </option>
      );
    })}
  </select>
</div>
           <div className="EditUser-form-group">
            <label>Release group</label>
            <select name="release_group" value={editedUser.release_group} onChange={handleChange}>
              {release_group.map((time) => (
                <option key={time} value={time}>{time}</option>
              ))}
            </select>
          </div>
          {(editedUser.privilege === "orgadmin" || editedUser.privilege === "siteadmin") && (
            <div className="EditUser-form-group">
              <label>User Manage Access</label>
              <select
                name="user_manage_access"
                value={editedUser.user_manage_access ? "true" : "false"}
                onChange={(e) =>
                  setEditedUser((prevUser) => ({
                    ...prevUser,
                    user_manage_access: e.target.value === "true",
                  }))
                }
              >
                {user_manage_access_options.map((option) => (
                  <option key={String(option.value)} value={String(option.value)}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

<div
  className="EditUser-form-group"
  style={{ marginTop: "5px", display: "flex", gap: "12px" }}
>
  <div style={{ display: "flex", alignItems: "center" }}>
    <input
      type="checkbox"
      checked={editedUser.is_log_enabled}
      onChange={(e) =>
        setEditedUser((prevUser) => ({
          ...prevUser,
          is_log_enabled: e.target.checked,
          log_level: e.target.checked ? "info" : ""
        }))
      }
      style={{ cursor: "pointer" }}
    />
    <span style={{ marginLeft: "8px", userSelect: "none" }}>Enable Logs</span>
  </div>


  {editedUser.is_log_enabled && (
    <>
      <span style={{ fontWeight: 500, fontSize: "14px" }}>Log Level:</span>
      <select
        className="EditUser-log-level-dropdown"
        style={{width:"100px"}}
        value={editedUser.log_level || ""}
        onChange={(e) =>
          setEditedUser((prevUser) => ({
            ...prevUser,
            log_level: e.target.value
          }))
        }
      >
        <option value="detail">Detail</option>
        <option value="debug">Debug</option>
        <option value="info">Info</option>
        <option value="warning">Warning</option>
        <option value="error">Error</option>
      </select>
    </>
  )}
</div>
       <div className="EditUser-form-group" style={{ marginTop: "10px" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <input
      type="checkbox"
      checked={editedUser.is_force_data_push_enabled}
      onChange={(e) =>
        setEditedUser((prevUser) => ({
          ...prevUser,
          is_force_data_push_enabled: e.target.checked,
        }))
      }
    />
    <span>Enable Forced Data Push</span>
  </div>
</div>


      <div className="EditUser-form-group" style={{ marginTop: "10px" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <input
      type="checkbox"
      checked={editedUser.is_leader}
      onChange={(e) =>
        setEditedUser((prevUser) => ({
          ...prevUser,
          is_leader: e.target.checked,
        }))
      }
    />
    <span>is leader</span>
  </div>
</div>




        <div className="EditUser-form-actions">
          <button type="submit" className="EditUser-save-btn">Save Changes</button>
          <button type="button" className="EditUser-cancel-btn" onClick={() => navigate(-1)}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditUser;
